import { DefaultTheme } from 'styled-components';

const lightTheme: DefaultTheme = {
  global: {
    bgColor: '#ffffff',
    textColor: '#2b2b2b',
    lightTextColor: '#898c8f',
    whiteTextColor: '#ffffff',
    borderColor: '#e0e0e4',
    mainColor: '#5352ED',
    mainColor2: '#efc002',
    errorColor: '#e84118',
    hoverBgColor: '#f0f1f4',
    logoGreen: '#3da463',
    logoBlue: '#00305d',
    logoYellow: '#f8b600',
  },
  ui: {
    menu: {
      bgColor: '#ffffff',
    },
    input: {
      borderColor: '#c9c9c9',
      disabledBgColor: '#f0f0f0',
    },
    button: {
      disabledBgColor: '#c9c9c9',
      iconButtonBgColor: '#f0f1f4',
      iconButtonHoverBgColor: '#E7E8F0',
    },
    loader: {
      trackColor: '#f0f0f0',
      thumbColor: '#0846a4',
    },
  },
  header: {
    bgColor: '#0f2e5f',
    logoBgColor: '#ffffff',
    searchBarBgColor: '#1c3e75',
    borderColor: '#0f2e5f',
    betaBgColor: '#f97f51',
  },
  sideBar: {
    accentBgColor: '#F1F5FD',
    accentTextColor: '#0953C3',
    textColor: '#6b6b6b',
  },
  home: {
    cardLoaderBgColor: '#dfdfdf',
    bgColor: '#f5f6fa',
  },
  editor: {
    flowBgColor: '#F9F9FC',
    edgeColor: '#c0c0c0',
    resizerBgColor: '#a0a0a0',
    loaderTrackColor: '#ffffff',
    loaderThumbColor: '#0F2E5F',
    creditButtonBgColor: '#fffcda',
    creditButtonIconColor: '#efc002',
    codeChangeAlertBgColor: '#FFFDC6',
    codeChangeAlertTextColor: '#2b2b2b',
    blockNode: {
      inputBgColor: '#ffffff',
      hoverBgColor: 'rgba(255, 255, 255, 0.4)',
      hoverBorderColor: '#1C8CE9',
    },
    csvTable: {
      headBgColor: '#eaeaef',
      borderColor: '#b0b0b0',
    },
  },
};

export default lightTheme;
